export const informationLink =
  "https://www.smartiscity.gr/dimos-ampelokipi-menemeni/";
export const informationLinkEN =
  "https://www.smartiscity.gr/dimos-ampelokipi-menemeni/";

// export const diavLink = "https://skoufas.diavouleuseis.gr";

export const applicantsCitizen = [
  {
    name: "Σύνδεση",
    url: "https://cityzenapp.zitsa.gov.gr/cityzen/zitsa/login",
  },
  {
    name: "Εγγραφή",
    url: "https://cityzenapp.zitsa.gov.gr/cityzen/zitsa/register",
  },
  {
    name: "Πληροφορίες",
    url: "https://cityzenapp.zitsa.gov.gr/cityzen/zitsa",
  },
];

export const androidAppLink =
  "https://play.google.com/store/apps/details?id=gr.dotsoft.volosAir";
export const iosAppLink =
  " https://apps.apple.com/us/app/volosair/id6748994282";

export const welcomeMessageContent = [
  "Ο Δήμος Βόλου σας καλωσορίζει στην Πύλη Έξυπνης Πόλης.",
  "Ενημερωθείτε για τις συνθήκες που επικραλτούν στην πόλη μας.",
];

export const baseUrl = "https://volos.smartiscity.gr";

// export const allTypesUrl = baseUrl + "/api/api.php?func=sensortypes";
export const allTypesUrl =
  "https://volos.smartiscity.gr/api/api.php?func=sensortypes";
export const allSensorsUrl =
  "https://nasousa.smartiscity.gr/api/api.php?func=allsensors";

export const UvUrl = baseUrl + "/api/api.php?func=indexes";
export const enviURL = "https://volos.smartiscity.gr/api/api.php?func=envi";
export const meshURL = baseUrl + "/api/api.php?func=mesh";
// export const meteoURL = "https://ampelokipoi.smartiscity.gr/api/api.php?func=meteo";
export const meteoURL = "https://volos.smartiscity.gr/api/api.php?func=meteo";
export const poiURL = baseUrl + "/api/api.php?func=pois";
export const fleetoUrl = baseUrl + "/api/api.php?func=fleeto";
export const binsUrl = baseUrl + "/api/api.php?func=bins";
export const hydroUrl = baseUrl + "/api/api.php?func=hydro";
export const weatherUrl =
  "https://nasousa.smartiscity.gr/api/api.php?func=forecast";
// baseUrl + "/api/api.php?func=forecast";
export const wifiUrl = baseUrl + "/api/api.php?func=hotspot";
export const parkingUrl = baseUrl + "/api/api.php?func=parkingAll";
export const allBinsCharts = baseUrl + "/api/api.php?func=allbinstats";
export const specificBinChart = baseUrl + "/api/api.php?func=binstats";

export const chartsUrls = baseUrl + "/api/api.php?func=stats";

export const gallerySmall =
  "https://volos.smartiscity.gr" + "/gallery/vars/Small/";
export const galleryBig = "https://volos.smartiscity.gr" + "/gallery/vars/Big/";

// settings
export const showEnvironmentAddress = true;
